module.exports = __webpack_public_path__ + "static/media/iron.ae28ed31.png";